/**
 * Primitivas de GATE compartilhadas por todo terceiro que este app carrega sob
 * condição (Sentry, OpenReplay, e o que vier depois).
 *
 * Saíram de `sentry/sentry-config.ts` quando o OpenReplay passou a precisar das
 * três: nenhuma delas tem nada de Sentry. O `sentry-config.ts` as re-exporta,
 * então nada que já as importava de lá precisou mudar.
 *
 * Funções puras, sem Angular e sem SDK — é o que permite testar cada gate
 * isoladamente, e é o teste do gate que impede uma conta (ou um disco) de
 * estourar.
 */

/** Hostnames de desenvolvimento — mesma regra do TraceTransportService. */
export function ehLocalhost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1'
    || hostname === '0.0.0.0' || /\.local$/.test(hostname);
}

/** Lê o sinal Do Not Track nas três grafias que os browsers já usaram. */
export function lerDoNotTrack(nav: any, win: any): boolean {
  try {
    const v = (nav && (nav.doNotTrack || nav.msDoNotTrack)) || (win && win.doNotTrack);
    return v === '1' || v === 'yes' || v === 1 || v === true;
  } catch (e) {
    return false;
  }
}

/**
 * Prefixos de ambiente que aparecem como PRIMEIRO segmento do path.
 *
 * Lista, e não uma cadeia de `||`, porque ela já foi esquecida duas vezes: o
 * `blue` e o `yellow` entraram depois, e um prefixo faltando aqui faz o NOME DO
 * AMBIENTE virar o slug do restaurante — a tag do Sentry e a metadata
 * `restaurant_url` do OpenReplay passam a dizer "yellow" para toda loja.
 */
const PREFIXOS_DE_AMBIENTE = ['app', 'green', 'blue', 'yellow'];

/**
 * Slug do restaurante a partir do path (`/app/<slug>/...`, `/green/<slug>/...`
 * ou `/<slug>/...` em dev). Vira TAG no Sentry e metadata no OpenReplay: sem
 * ela, "erro subiu" não vira "erro subiu NA LOJA X" — e é sempre por loja que o
 * suporte pergunta.
 */
export function slugDoPath(pathname: string): string {
  try {
    const seg = String(pathname || '').split('/').filter(Boolean);
    const primeiro = seg[0];
    const slug = PREFIXOS_DE_AMBIENTE.indexOf(primeiro) !== -1 ? seg[1] : primeiro;
    if (!slug || slug.indexOf('.') > -1) return '';
    return /^[a-zA-Z0-9_-]+$/.test(slug) ? slug.slice(0, 60) : '';
  } catch (e) {
    return '';
  }
}
